import { hover } from 'pobble-components/dist/jss-mixins'

const styles = ({ COLORS, FONT_SIZES, BREAKPOINTS }) => ({
  item: {
    margin: '0 0 0 60px',
    padding: '0 16px 5px',
    position: 'relative',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      margin: '0 0 0 30px'
    },
    '&:first-child': {
      margin: '0'
    },
    '&:after': {
      content: '""',
      transition: 'transform 0.3s',
      height: '2px',
      backgroundColor: COLORS.BLUE.NORMAL,
      width: '100%',
      position: 'absolute',
      bottom: '0',
      left: '0',
      transform: 'scaleX(0)'
    }
  },
  activeItem: {
    '&:after': {
      transform: 'scaleX(1)'
    },
    '& $link': {
      color: COLORS.BLUE.NORMAL
    }
  },
  link: {
    transition: 'color 0.3s',
    textDecoration: 'none',
    color: COLORS.TEXT.MID_GREY.NORMAL,
    ...FONT_SIZES.HEADING_BIG.STYLE,
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      ...FONT_SIZES.HEADING_MEDIUM.STYLE
    },
    ...hover({
      color: COLORS.BLUE.NORMAL
    })
  }
})

export default styles
